unable to read source [project]/node_modules/src/code-decoder.ts